import React from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import selecteExpenses from '../selectors/expenses';
import selecteExpensesTotal from '../selectors/expenses-total';

export const ExpensesSummary = ({ expenseCount, expensesTotal }) => {
    const expenseWord = expenseCount === 1 ? 'expense' : 'expenses';
    const formattedExpensesTotal = numeral(expensesTotal / 100).format('$0,0.00');
    return (
        <div>
            <h1>Viewing {expenseCount} {expenseWord} total {formattedExpensesTotal}</h1>
        </div>
    );
}

const mapStateToProps = (state) => {
    const visibleExpenses = selecteExpenses(state.expenses, state.filters);

    return {
        expenseCount: visibleExpenses.length,
        expensesTotal: selecteExpensesTotal(visibleExpenses)
    };
};

export default connect(mapStateToProps)(ExpensesSummary);